import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
 private apiUrl = 'https://countriesnow.space/api/v0.1/countries/cities';
  constructor(private http: HttpClient) {}

  getCitiesByCountry(countryName: string): Observable<any> {
    return this.http.post(this.apiUrl, { country: countryName });
  }


  getCurrentLocation() {
    return new Promise((resolve, reject) => {
      try{
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              if (position) {
                console.log(
                  'Latitude: ' +
                    position.coords.latitude +
                    ' Longitude: ' +
                    position.coords.longitude
                );
                let lat = position.coords.latitude;
                let lng = position.coords.longitude;

                const location = {
                  lat,
                  lng,
                };
                resolve(location);
              }
            },
            (error) => {
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  reject('User denied the request for Geolocation.');
                  break;
                case error.POSITION_UNAVAILABLE:
                  reject('Location information is unavailable.');
                  break;
                case error.TIMEOUT:
                  reject('The request to get user location timed out.');
                  break;
                default:
                  reject('An unknown error occurred.');
                  break;
              }
            }
          );
        } else {
          reject('Geolocation is not supported by this browser.');
        }

      }
      catch(e){
        console.log(e);
        const location = {
          lat:0,
          lng:0,
        };
        resolve(location);
        }
    });
  }

  getUserCurrentLocation(): Promise<{ lat: number; lng: number }> {
    return new Promise<{ lat: number; lng: number }>((resolve, reject) => {
      if (!navigator.geolocation) {
        reject('Geolocation is not supported by your browser.');
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          (error) => {
            reject(`Geolocation error: ${error.message}`);
          }
        );
      }
    });
  }

  reverseGeocode(lat: number, lng: number): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      const latlng = { lat, lng };

      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          resolve(results[0].formatted_address);
        } else {
          reject('Unable to retrieve address');
        }
      });
    });
  }

  async getCurrentLocationWithGoogle(): Promise<{ lat: number; lng: number }> {
    return new Promise(async (resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            // Use the browser's geolocation data
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            resolve({ lat, lng });
          },
          async (error) => {
            // Handle browser-specific geolocation errors
            switch (error.code) {
              case error.PERMISSION_DENIED:
                reject('Location access denied by the user.');
                break;
              case error.POSITION_UNAVAILABLE:
                reject('Location information is unavailable.');
                break;
              case error.TIMEOUT:
                reject('The request to get location timed out.');
                break;
              default:
                reject('An unknown error occurred in geolocation.');
            }

            // If geolocation fails, fallback to Google API
            try {
              const response = await fetch(
                `https://www.googleapis.com/geolocation/v1/geolocate?key=${environment.geoLocationApiKey}`,
                {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ considerIp: true }),
                }
              );
              const data = await response.json();

              // Log full response for debugging
              console.log('Google API Response:', data);

              // Check if data.location exists
              if (data?.location?.lat && data?.location?.lng) {
                resolve({
                  lat: data.location.lat,
                  lng: data.location.lng,
                });
              } else {
                reject('Google API did not return valid location data.');
              }
            } catch (googleError) {
              console.error('Google Geolocation API error:', googleError);
              reject('Google API error occurred.');
            }
          },
          { enableHighAccuracy: true } // Add this line
        );
      } else {
        reject('Geolocation is not supported by this browser.');
      }
    });
  }


}
